import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { useMemo } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { init } from 'zod-empty';
import { FormType } from './types';
import { FormManifest, makeManifest } from './utils/makeManifest';
type UseFormEngineReturn = {
  form: UseFormReturn<Record<string, unknown>>;
  manifest: FormManifest;
};
export function useFormEngine(formDefinition: FormType): UseFormEngineReturn {
  /**
   * 1️⃣ Compile manifest
   */
  const manifest = useMemo(() => makeManifest(formDefinition), [formDefinition]) as FormManifest;
  const resolver = useMemo(() => standardSchemaResolver(manifest.formSchema), [manifest.formSchema]);
  const defaultValues = useMemo(() => init(manifest.formSchema), [manifest.formSchema]);

  /**
   * 2️⃣ Initialise RHF
   */
  const form = useForm({
    resolver,
    mode: 'onTouched',
    defaultValues
    //shouldUnregister: true,
  });
  return {
    form,
    manifest
  };
}